var _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivestepbonus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.355 9.973L12 18.247 4.645 9.973 7.25 6.5h9.5l2.605 3.473z",
    stroke: "#572DA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.25L8 10l-.75-3.5M12 18.25L16 10l.75-3.5M4.5 10h15",
    stroke: "#572DA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10l4-3.5 4 3.5",
    stroke: "#572DA5",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#572DA5"
  })));
}
SvgActivestepbonus.displayName = 'Activestepbonus';
export default SvgActivestepbonus;